/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ReportDefs from './defs.defs.js'

const $nsid = 'tools.ozone.report.reassignQueue'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  reportId: /*#__PURE__*/ l.integer(),
  queueId: /*#__PURE__*/ l.integer(),
  comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  report: /*#__PURE__*/ l.ref<ReportDefs.ReportView>(
    (() => ReportDefs.reportView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Manually reassign a report to a different queue (or unassign it). Records a queueActivity entry on the report. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'ReportNotFound',
  'ReportClosed',
  'AlreadyInTargetQueue',
  'QueueNotFound',
  'QueueDisabled',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
